/**
 * Team Inbox — open a WhatsApp conversation with a number that has never
 * written to us. Thin wrapper over the `waStartConversation` callable.
 *
 * This does NOT send. It returns the conversationKey; the caller then uses the
 * SAME `sendTemplate` path every other outbound template uses, so the approved
 * allow-list and one-message discipline stay in one place on the server.
 */
export interface StartConversationResult {
  conversationKey: string;
  /** true when we were already talking to this number — no new thread minted. */
  existing: boolean;
  /** Who owns it today — lets the caller skip a redundant re-assign. */
  ownerUid: string | null;
  participantName: string;
  phone: string;
}

export async function startWaConversation(params: {
  phone: string;
  name?: string;
}): Promise<StartConversationResult> {
  const [{ functions }, { httpsCallable }] = await Promise.all([
    import('../../../lib/firebase'),
    import('firebase/functions'),
  ]);
  const fn = httpsCallable<typeof params, StartConversationResult>(
    functions,
    'waStartConversation',
  );
  const res = await fn(params);
  return res.data;
}
